import React from 'react';
import moment from 'moment';

import {
  MCButton,
  SelectField,
  TextAreaField,
  TextField,
  AutoCompleteField
} from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { addressObject, lang, objectToSelectList, rangeToSelectList } from 'src/helpers';
import constants from 'src/constants';
import { AvatarImages, Treatment } from './components';
import { DateSelects } from '../complex';
import DefaultPdfImg from 'src/assets/images/default-pdf-img.png';
import LANG_CONST from 'src/helpers/lang/const';
import { EmailPhoneSection, FormRow } from '../Form';
import { AlertBox } from '../alert';

const apiStateId = 'updateDoctor';

class DoctorInput extends BaseComponent {
  componentDidMount() {
    const { model } = this.props;
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    const { model } = this.props;
    model.unsubscribe(this.subscription);
  }

  render() {
    const {
      model,
      certificate = false,
      emailReadonly = false,
      phoneReadonly = false,
      imagesEnable = false
    } = this.props;
    const { handleChangeProfile, handleBlur } = model;
    const { invalid, ...createState } = model.getApiState(apiStateId);

    if (createState.error === 'URLNAME_TAKEN') {
      invalid['username'] = createState.errorMessage;
    }

    if (createState.error === 'EMAIL_TAKEN') {
      invalid['email'] = createState.errorMessage;
    }
    const address = addressObject(model.state);
    return (
      <>
        <AvatarImages
          avatar={model.input('avatar')}
          images={model.input('images')}
          imagesEnable={imagesEnable}
          invalid={{}}
          onAvatarChange={(v) => {
            model.resetApiState(apiStateId);
            model.handleChangeAvatar(v);
          }}
          onImagesChange={(v) => {
            model.resetApiState(apiStateId);
            handleChangeProfile('images', v);
          }}
        />
        {invalid?.avatar && (
          <AlertBox
            message={invalid?.avatar}
            onClose={() => {
              model.setInvalidApi(apiStateId, { ...invalid, avatar: null });
            }}
          />
        )}
        <div className={'mc-value-620'}>{lang.t(LANG_CONST.titles.doctor_info)}</div>
        <div className={'mc-flex-20-col'}>
          <FormRow addColspan={1}>
            <TextField
              template={6}
              label={LANG_CONST.username}
              name={'username'}
              value={model.input('username')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <FormRow>
            <TextField
              template={6}
              label={LANG_CONST.first_name}
              name={'firstName'}
              value={model.input('firstName')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
            <TextField
              template={6}
              label={LANG_CONST.last_name}
              name={'lastName'}
              value={model.input('lastName')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <EmailPhoneSection
            defaultCountryName={model.state.tempCountryAddress}
            emailReadonly={emailReadonly}
            phoneReadonly={phoneReadonly}
            email={model.input('email')}
            handleChangeProfile={handleChangeProfile}
            handleBlur={handleBlur}
            navigate={this.navigate}
            phoneNumber={model.input('phoneNumber').toString()}
          />
          <div className={'mc-flex-col mc-grow'}>
            <div className={'mc-label-418'}>{lang.t(LANG_CONST.birthday)}</div>
            <FormRow>
              <DateSelects
                close={false}
                className={'mc-flex-20 mc-user-birthday'}
                template={'6'}
                minDate={moment().startOf('year').year(1900)}
                maxDate={moment().add({ years: -18 }).endOf('year')}
                onChange={(n, v) => handleChangeProfile(n, v)}
                invalid={invalid}
                name={'birthday'}
                date={model.input('birthday')}
              />
            </FormRow>

            {invalid['birthday'] && <p className='mc-form-invalid-text'>{invalid['birthday']}</p>}
          </div>
          <FormRow addColspan={1}>
            <SelectField
              template={6}
              width={'100%'}
              options={objectToSelectList(LANG_CONST.constants.gender)}
              label={LANG_CONST.gender}
              isSearchable={false}
              name={'gender'}
              value={model.input('gender')}
              onChange={handleChangeProfile}
              invalid={invalid}
            />
          </FormRow>
        </div>
        <div className={'mc-value-620'}>{lang.t(LANG_CONST.titles.qualifications)}</div>
        <div className={'mc-flex-20-col'}>
          <FormRow>
            <SelectField
              template={6}
              isClearable={false}
              label={'Doctor type'}
              name={'doctorType'}
              value={model.input('doctorType')}
              options={constants.general.doctor_types}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
            <SelectField
              template={6}
              isClearable={false}
              label={'Year of starting'}
              name={'yearOfStarting'}
              value={model.input('yearOfStarting')}
              options={rangeToSelectList(1900, moment().year(), true)}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>

          <FormRow>
            <SelectField
              template={6}
              placeholder={LANG_CONST.text.enter_here}
              label={LANG_CONST.speciality}
              isMultipleSpecial={true}
              isClearable={false}
              options={objectToSelectList(LANG_CONST.constants.specialist, true)}
              name={'specialist'}
              value={model.input('specialist')}
              onChange={handleChangeProfile}
              invalid={invalid}
            />
            <TextField
              template={6}
              label={'Institution'}
              name={'institution'}
              value={model.input('institution')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <FormRow addColspan={1}>
            <TextField
              template={6}
              label={LANG_CONST.sub_speciality}
              name={'subSpeciality'}
              placeholder={''}
              value={model.input('subSpeciality')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <FormRow>
            <TextAreaField
              template={6}
              rows={4}
              label={LANG_CONST.description}
              name={'description'}
              placeholder={''}
              value={model.input('description')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          {certificate && (
            <div className={'mc-flex-col'}>
              <div className={'mc-label-416'}>{lang.t(LANG_CONST.upload_cert)}</div>
              <TextField
                template={6}
                multiple={true}
                files={model.state.certificateFiles}
                type={'file'}
                name={'certificateFiles'}
                onChange={(n, v, e) => {
                  if (e.target.files.length > 0) {
                    handleChangeProfile(n, [...e.target.files]);
                  }
                }}
                onBlur={handleBlur}
                invalid={invalid}
                accept={'application/pdf, image/*'}
                thumbnail={DefaultPdfImg}
              />
            </div>
          )}
        </div>
        <div className={'mc-value-620'}>{lang.t(LANG_CONST.titles.treatments)}</div>

        <FormRow>
          <div className={'mc-flex-col'}>
            <Treatment
              treatments={model.input('treatments')}
              defaultTreatments={model.defaultTreatments}
              handleChange={handleChangeProfile}
              handleBlur={handleBlur}
              invalid={invalid}
            />
          </div>
        </FormRow>
        <div className={'mc-value-620'}>{lang.t(LANG_CONST.your_address)}</div>
        <div className={'mc-flex-20-col'}>
          <FormRow>
            <TextField
              template={6}
              label={LANG_CONST.address.address_line}
              name={'address'}
              placeholder={''}
              value={model.input('address')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <FormRow>
            <AutoCompleteField
              template={6}
              label={LANG_CONST.address.country}
              name={'countryAddress'}
              value={model.input('countryAddress')}
              onChange={(n, v) => {
                if (model.input('countryAddress') !== v) {
                  handleChangeProfile(n, v);
                  handleChangeProfile('stateAddress', '');
                  handleChangeProfile('cityAddress', '');
                }
              }}
              autocompleteApi='country'
              autocompleteParams={{
                limit: 300
              }}
              invalid={invalid}
            />
            <AutoCompleteField
              template={6}
              label={LANG_CONST.address.state}
              name={'stateAddress'}
              value={model.input('stateAddress')}
              onChange={(n, v) => {
                handleChangeProfile(n, v);
                handleChangeProfile('cityAddress', '');
              }}
              invalid={invalid}
              autocompleteParams={{
                countryCode: address.countryCode,
                limit: 100
              }}
              autocompleteApi='state'
            />
            <AutoCompleteField
              template={6}
              label={LANG_CONST.address.city}
              name={'cityAddress'}
              value={model.input('cityAddress')}
              onChange={(n, v) => {
                handleChangeProfile(n, v);
              }}
              invalid={invalid}
              autocompleteApi='city'
              autocompleteParams={{
                countryCode: address.countryCode,
                stateCode: address.stateCode,
                limit: 20
              }}
            />
          </FormRow>
          <FormRow addColspan={2}>
            <TextField
              template={6}
              label={LANG_CONST.address.zip}
              name={'zipcode'}
              value={model.input('zipcode')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
        </div>
        <div className={'mc-value-620'}>{lang.t(LANG_CONST.clinic_hospital)}</div>
        <div className={'mc-flex-20-col'}>
          <FormRow addColspan={1}>
            <TextField
              template={6}
              label={LANG_CONST.clinic_hospital}
              name={'hospitalName'}
              value={model.input('hospitalName')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <FormRow>
            <TextAreaField
              template={6}
              rows={4}
              label={LANG_CONST.address.address}
              name={'hospitalAddress'}
              value={model.input('hospitalAddress')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
        </div>
        <div className={'mc-flex-20'}>
          <MCButton
            label={LANG_CONST.buttons.delete_account}
            medium
            radius
            senary
            light
            onClick={() => model.emit('deleteAccount')}
          />
        </div>
      </>
    );
  }
}

export default DoctorInput;
